import { cn } from "@/lib/utils";
import { Button } from "@/src/components/Button/Button";
import InputComponent from "@/src/components/Input/Input";
import { Modal } from "@/src/components/Modal/Modal";
import { textVariants } from "@/src/components/Text/Text";
import { Card } from "@/src/components/shad/card";
import { useWalletData } from "@/src/hooks/useCoinData";
import refresh from "@assets/icons/Refresh.svg";
import Transfer from "../Forms/Transfer";

import { useState } from "react";
import Loader from "@/src/components/Loader";
import { formatNumber } from "@/src/utils";
import { useTranslation } from "react-i18next";

const Trading = () => {
  const { walletData, isLoading } = useWalletData();
  const [open, setOpen] = useState(false);
  const [selectedCoin, setSelectedCoin] = useState<WalletDataInfo | undefined>(
    undefined
  );
  const { t } = useTranslation();
  const trans = (key: string) => t(`app.wallet.trading.${key}`);
  // const [, setCoinId] = useUrlState("coin");

  if (isLoading) return <Loader />;

  return (
    <div className="mt-5">
      <Card className="p-4 flex justify-between items-center">
        <InputComponent
          placeholder="Search"
          className="lg:w-1/4 md:w-2/4 w-3/4"
        />
        <Button className="bg-[#F6F8FF] dark:bg-grey-500 px-3 py-1 text-gray-500 dark:text-gray-200 font-normal flex gap-1 items-center">
          <img src={refresh} className="h-5 w-5" alt="arrow" />
          {trans("refreshButton")}
        </Button>
      </Card>
      <div className="mt-2">
        <div className="grid grid-cols-3 md:grid-cols-4 p-3">
          <span className={textVariants({ size: "sm", variant: "desc" })}>
            {trans("table.headers.coin")}
          </span>
          <span
            className={cn(
              textVariants({ size: "sm", variant: "desc" }),
              "text-right md:block hidden"
            )}
          >
            {trans("table.headers.usdBalance")}
          </span>
          <span
            className={cn(
              textVariants({ size: "sm", variant: "desc" }),
              "text-right"
            )}
          >
            {trans("table.headers.cryptoBalance")}
          </span>
          <span
            className={cn(
              textVariants({ size: "sm", variant: "desc" }),
              "text-right"
            )}
          >
            {trans("table.headers.action")}
          </span>
        </div>
        <div className="bg-white dark:bg-grey-700 grid divide-y dark:divide-grey-500 divide-gray-200 ">
          {walletData?.wallets?.map((coin, index) => (
            <div key={index} className="grid-cols-3 md:grid-cols-4 grid p-4">
              <div className="flex items-center gap-2">
                <img src={coin?.image} className="h-6 w-6" alt="coin" />
                <div className="flex flex-col">
                  <span
                    className={textVariants({
                      font: "semibold",
                      case: "uppercase",
                    })}
                  >
                    {coin?.ticker}
                  </span>
                  <span
                    className={textVariants({ size: "xs", variant: "desc" })}
                  >
                    {coin?.label}
                  </span>
                </div>
              </div>
              <div className="items-center md:justify-end md:grid hidden">
                <span className={textVariants({ size: "sm" })}>
                  ${formatNumber(coin?.funding_fiat_balance)}
                </span>
                {/* <span className={textVariants({ size: "sm" })}>
                  {coin?.spot_balance}
                </span> */}
              </div>
              <div className="grid items-center md:justify-end">
                <span className={textVariants({ size: "sm" })}>
                  {coin?.funding_balance}
                </span>
                {/* <span className={textVariants({ size: "sm" })}>
                  {coin?.funding_balance}
                </span> */}
              </div>
              <div className="flex justify-end">
                <div>
                  <span
                    onClick={() => [
                      setOpen(true),
                      setSelectedCoin(coin),
                      // setCoinId(coin?.coin__id),
                    ]}
                    className={cn(
                      textVariants({ variant: "link", size: "sm" }),
                      "bg-[#EDF0FA] dark:bg-grey-600 px-3 py-1 rounded-xl cursor-pointer"
                    )}
                  >
                    {" "}
                    {trans("table.headers.transfer")}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Modal open={open} setOpen={setOpen} title="Transfer" setter="state">
        <Transfer coin={selectedCoin} />
      </Modal>
    </div>
  );
};

export default Trading;
